import keys from '@debbie/common/dist/cache/keys.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import { ensureUpdatesLoadedByRef, updatesEntity, } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import { Button, DateInput, File, Input } from '../../../index.js';
const Register2Paategning = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.tribunalCase.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const [loading, setLoading] = useState(false);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference || 'FS');
    const [date, setDate] = useState(moment());
    const [file, setFile] = useState(null);
    const dropzoneRef = useRef(null);
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const uploadFile = async (acceptedFiles) => {
        for (let i = 0; i < acceptedFiles.length; i++) {
            const acceptedFile = acceptedFiles[i];
            const content = await promiseFileReader(acceptedFile);
            const { file } = await files.save({
                content: content.split('base64,')[1],
                name: acceptedFile.name,
                contentType: acceptedFile.type,
            });
            setFile(file);
        }
    };
    const register2Paategning = async () => {
        setLoading(true);
        try {
            if (!date) {
                throw new Error('Date is required');
            }
            await tribunalAPI.createTribunalJob({
                type: DKTribunalJobType.Register2Paategning,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    date: date.toISOString(),
                    fileId: file?.fileId,
                },
                caseId: props.tribunalCase.caseId,
                reference: fsNo.trim(),
            });
            if (singleCase) {
                q.invalidate([
                    ...keys.write.create(updatesEntity),
                    ...keys.write.create(caseVouchersEntity),
                ]);
                await ensureUpdatesLoadedByRef(singleCase.caseId);
            }
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement(Dropzone, { style: {}, disableClick: true, ref: dropzoneRef, multiple: true, onDrop: uploadFile },
        React.createElement("h4", null, lang.tribunal.register2Paategning),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => setFsNo(e.target.value) })),
        React.createElement(DateInput, { placeholder: lang.tribunal.andenPaategningDate, value: date, onChange: (d) => setDate(d), allowNull: true }),
        React.createElement(Button, { onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            }, size: "small", theme: "secondary", block: true }, lang.tribunal.addDocument),
        file && (React.createElement("p", null,
            React.createElement(File, { file: file, removable: true, onRemove: () => setFile(null) }))),
        React.createElement("br", null),
        React.createElement(Button, { onClick: register2Paategning, loading: loading, disabled: !date, block: true }, lang.tribunal.register2Paategning)));
};
export default Register2Paategning;
//# sourceMappingURL=Register2Paategning.js.map